import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';

import axios from 'utils/axios';
import Text from 'ui/Text';
import Auth from 'shared/Auth';

class EightIndicators extends Component {
  constructor() {
    super();

    this.state = {
      cdrScores: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.retrieveCDR();
  }

  retrieveCDR = () => {
    this.setState({ loading: true });

    let payload = {
      user_id: get(Auth.getUser(), 'id'),
    };

    axios
      .post(`/stage/${get(Auth.getUser(), 'current_stage_id')}/score`, payload)
      .then(response => {
        let cdrScores = map(get(response.data, `${payload.user_id}`), (score, value) => score[0]);
        this.setState({ cdrScores, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  displayScore = sectionTitle => {
    let currentScore = find(this.state.cdrScores, item => {
      let formTitle = get(item, 'form_title');

      return formTitle.match(sectionTitle);
    });

    return currentScore ? `${get(currentScore, 'score', 'N/A')}` : 'N/A';
  };

  render() {
    if (this.state.loading) {
      return (
        <Text type="sub-head" modifiers="text-center">
          <FormattedMessage
            id="Questionnaire.CDR.LoadingCDR"
            defaultMessage="Loading CDR Scores..."
          />
        </Text>
      );
    }

    return (
      <div className="intro-banner eight-indicators">
        <Text modifiers="question-title primary-blue">
          <FormattedMessage
            id="Questionnaire.CDR.SubMenuItem.2"
            defaultMessage="How You Performed"
          />
        </Text>
        <Text type="explanation">
          <FormattedMessage
            id="Questionnaire.CDR.EightIndicators.Explanation"
            defaultMessage="There are different ways to categorize organizational capacity, but we use the following elements:"
          />
        </Text>
        <br />
        <table className="cdr-table">
          <thead>
            <tr>
              <th>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.CapacityElement"
                    defaultMessage="Capacity Element"
                  />
                </Text>
              </th>
              <th>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.WhatWeAsses"
                    defaultMessage="What we are trying to assess?"
                  />
                </Text>
              </th>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <th>
                  <Text type="small-bold" modifiers="uppercase">
                    <FormattedMessage
                      id="Questionnaire.CDR.EightIndicators.HowIPerformed"
                      defaultMessage="How I performed?"
                    />
                  </Text>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.StrategicAbility.Title"
                    defaultMessage="Strategic Ability and Adaptability"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.StrategicAbility.Assess"
                    defaultMessage="This indicator assesses clarity of strategy, priorities; readiness and ability to pursue them; ability to understand and adapt to changing circumstances and opportunities.  It examines the framework that you have put in place to fulfill your mission, e.g. goal setting, measuring success and appropriate resource allocation. "
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Strategic Ability')}</Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Leadership.Title"
                    defaultMessage="Leadership and Governance"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Leadership.Assess"
                    defaultMessage="This indicator evaluates the capacity of your leadership team to guide your organization’s work through strategy, vision and inspiration. It also analyzes the use of governance structures, which maintain your organization’s accountability, reputation and integrity."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">
                    {this.displayScore('Leadership and Governance')}
                  </Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Finance.Title"
                    defaultMessage="Financial Health & Organizational Management"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Finance.Assess"
                    defaultMessage="This indicator reviews your organization’s resources and income, professionalism of financial management and your financial and reporting systems. This review is vital to verifying the long-term viability and success of your organization based on sound financial management."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Financial Health')}</Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.HumanResource.Title"
                    defaultMessage="Human Resources and Staff Development"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.HumanResource.Assess"
                    defaultMessage="This indicator analyzes the  staff size, quality, and skill sets to address mission and drive performance. It also looks at  human resource management, which plays a strategic role in managing people and the overall culture and direction of your organization."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Human Resources')}</Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Communications.Title"
                    defaultMessage="Communications"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Communications.Assess"
                    defaultMessage="This indicator assesses your organization’s ability to identify, reach and influence audiences in line with your mission. A communication strategy ensures that you maintain consistent messaging about your work and develop relevant and timely material to help you achieve your organizational objectives."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Communications')}</Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Monitoring.Title"
                    defaultMessage="Monitoring and Evaluation"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Monitoring.Assess"
                    defaultMessage="This indicator evaluates whether or not your organization uses performance indicators and uses the lessons learned for continuous improvement of your organization."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Monitoring')}</Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Partnerships.Title"
                    defaultMessage="Partnerships and Alliances"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Partnerships.Assess"
                    defaultMessage="This indicator measures your organization’s capacity and reputation for creating value with others. It evaluates your organization’s use of networks and your willingness to collaborate with partners to further organizational goals."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Partnerships')}</Text>
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text type="small-bold" modifiers="uppercase">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Operations.Title"
                    defaultMessage="Operations"
                  />
                </Text>
              </td>
              <td>
                <Text modifiers="normal__smaller">
                  <FormattedMessage
                    id="Questionnaire.CDR.EightIndicators.Operations.Assess"
                    defaultMessage="This indicator evaluates whether your organization has adequate tools, resources, and structures to effectively manage operational risks and implement programs."
                  />
                </Text>
              </td>
              {get(Auth.getUser(), 'is_legally_registered') && (
                <td>
                  <Text modifiers="normal__smaller">{this.displayScore('Operations')}</Text>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default EightIndicators;



// WEBPACK FOOTER //
// ./src/components/CDRSections/EightIndicators.js